import React from 'react'
import styled from 'styled-components'


const OverflowContainer = ({ width = "100%", flex = "nowrap", pad = "0", justify = "space-between", gap = "20px", bg = "transparent", scroll = "hidden", children }) => {
    return (
        <Wrap $width={width} $flex={flex} $pad={pad} $justify={justify} $bg={bg} $scroll={scroll} $gap={gap}>{children}</Wrap>
    )
}

export default OverflowContainer


const Wrap = styled.div`
width: ${(props) => (props.$width)};
display: flex;
flex-direction: row;
align-items: center;
gap: ${(props) => (props.$gap)};
justify-content: ${(props) => (props.$justify)}; 
/* background: ${(props) => (props.$bg)}; */
background: red;
overflow-x: scroll;
padding: ${(props) => (props.$pad)};
/* flex-wrap: ${(props) => (props.$flex)}; */
height: 50px;

`